export default __webpack_public_path__ + "static/media/american-express.a3fdc862.png";